<template>

	<section class="container margin-t-100" dusk="success">

		<section class="container__body container__body--sm">

			<h1>Ordren er oprettet</h1>

			<p>Der bliver nu sendt en ordrebekræftelse til kunden pr. e-mail som indeholder hele ordren.</p>

			<p>Du kan også downloade din ordrebekræftelse nedenfor som PDF og sende til dem.</p>

			<a class="btn--primary btn--sm primary--copper margin-t-25" :href="pdf" target="_blank">Download</a>

		</section>

	</section>

</template>

<script>
	import {mapGetters} from 'vuex';
    import totalCalculation from './../mixins/totalCalculation.js';
	import moment from 'moment';
    export default {
        name: "completedOrder",
        mixins:[totalCalculation],
		computed:{
			...mapGetters({
                order:'order',
                packaging_fee:'packaging_fee',
		  	 }),
			pdf(){
				return this.order.invoiceLink;
			},
        },
        mounted(){
            /*const dataForDataLayer = {
                event: 'orderCompleted',
				order: {
                    currency: 'DKK',
                    total: this.stripeAmount(this.total).amountForEditing,
                    deliveryFee: this.stripeAmount(this.order.delivery.delivery_fee).amountForEditing,
                    productName: this.product.title,
					productCategory: this.product.category_title,
                    quantity: this.order.details.quantity,
					orderUuid: this.order.order_uuid
				},
				transactionId: this.order.order_uuid,
				transactionTotal: this.stripeAmount(this.total).amountForEditing,
				transactionShipping: this.stripeAmount(this.order.delivery.delivery_fee).amountForEditing,
				transactionProducts: [{
					'sku': this.order.order_uuid,
					'name': this.product.title,
					'category': this.product.category_title,
					'price': this.stripeAmount(this.total).amountForEditing / this.order.details.quantity,
					'quantity': this.order.details.quantity
				}]

            };

            console.log(dataForDataLayer);
            dataLayer.push(dataForDataLayer);
            */

        }
    }
</script>

<style scoped>

</style>
